import React from 'react';

import StoryAnalyzer from './Services/StoryAnalyzer';

const App: React.FC = () => {
  return (
    <StoryAnalyzer />
  );
}

export default App;
